import React from 'react';
import { motion } from 'framer-motion';
import { Circle } from 'lucide-react';
export interface Option {
  id: string;
  text: string;
}
interface QuizQuestionProps {
  question: string;
  options: Option[];
  onAnswer: (optionId: string) => void;
  imageUrl?: string;
  imageAlt?: string;
  compact?: boolean;
}
export function QuizQuestion({
  question,
  options,
  onAnswer,
  imageUrl,
  imageAlt,
  compact = false
}: QuizQuestionProps) {
  return <div className="w-full max-w-3xl mx-auto" data-id="element-73">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} className="bg-gray-50 rounded-xl border border-gray-100 shadow-sm overflow-hidden" data-id="element-74">
        <div className={`flex ${imageUrl ? 'flex-row' : ''}`} data-id="element-75">
          {imageUrl && <div className="w-2/5 shrink-0 overflow-hidden" data-id="element-76">
              <img src={imageUrl} alt={imageAlt || 'Quiz illustration'} className="w-full h-full object-cover" data-id="element-77" />
            </div>}

          <div className={`${compact ? 'p-3 md:p-4' : 'p-4 md:p-5'} flex-1 ${imageUrl ? '' : 'w-full'}`} data-id="element-78">
            <h2 className={`${compact ? 'text-sm md:text-base' : 'text-base md:text-lg'} font-bold text-brand-primary ${compact ? 'mb-2' : 'mb-3'} leading-tight`} data-id="element-79">
              {question}
            </h2>

            <div className={compact ? 'space-y-1' : 'space-y-1.5'} data-id="element-80">
              {options.map((option, index) => <motion.button key={option.id} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: index * 0.1
            }} onClick={() => onAnswer(option.id)} className={`w-full text-left ${compact ? 'px-2.5 py-2' : 'p-2.5'} rounded-lg border-2 border-gray-200 bg-white text-text-subtle hover:bg-gray-50 hover:border-brand-primary/30 transition-all duration-200 flex items-start gap-2 group relative`} data-id="element-81">
                  <div className="mt-0.5 shrink-0 transition-colors text-gray-400 group-hover:text-button-hover" data-id="element-82">
                    <Circle className={compact ? 'w-3.5 h-3.5' : 'w-4 h-4'} data-id="element-83" />
                  </div>
                  <span className={`font-medium ${compact ? 'text-[12px] leading-snug' : 'text-sm'}`} data-id="element-84">
                    {option.text}
                  </span>
                </motion.button>)}
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}